import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2 } from "lucide-react";

export default function StatusPage() {
  const [v, setV] = useState(null);
  const [rates, setRates] = useState({});

  useEffect(() => {
    const load = () => {
      api.get("/version").then((r) => setV(r.data)).catch(() => {});
      api.get("/exchange-rates").then((r) => setRates(r.data.rates || {})).catch(() => {});
    };
    load(); const t = setInterval(load, 15000); return () => clearInterval(t);
  }, []);

  const grouped = v ? v.modules.reduce((acc, m) => { (acc[m.since] ||= []).push(m); return acc; }, {}) : {};
  const versions = Object.keys(grouped).sort().reverse();

  return (
    <div className="min-h-screen text-white">
      <nav className="glass sticky top-0 z-40 border-b border-white/10">
        <div className="max-w-6xl mx-auto flex items-center justify-between px-6 py-4">
          <Link to="/" data-testid="status-nav-logo" className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#d4af37] to-[#7a5f16] grid place-items-center font-display font-black text-black">★</div>
            <div className="leading-none">
              <div className="font-display text-lg font-bold">BlackStar</div>
              <div className="font-mono text-[10px] tracking-[0.3em] text-white/60">STATUS</div>
            </div>
          </Link>
        </div>
      </nav>
      <section className="max-w-6xl mx-auto px-6 py-16">
        <div className="chip green mb-4" data-testid="status-chip"><CheckCircle2 size={12}/> ALL SYSTEMS OPERATIONAL</div>
        <h1 className="font-display text-5xl md:text-6xl leading-tight">Live at <span className="text-[#d4af37]" data-testid="status-version">{v?.version || "…"}</span></h1>
        <p className="text-white/60 mt-3">Generated {v?.as_of ? new Date(v.as_of).toLocaleString() : "…"} · auto-refreshes every 15s</p>

        <div className="grid md:grid-cols-4 gap-4 mt-10">
          {[
            ["Modules live", v?.modules?.length ?? "…"],
            ["State-machine states", v?.state_machine_states ?? "…"],
            ["Licenses", v?.licenses ?? "…"],
            ["Partner ATMs", v?.atm_count ?? "…"],
          ].map(([k,val]) => (
            <div key={k} className="panel p-5" data-testid={`stat-${String(k).toLowerCase().replaceAll(" ","-")}`}>
              <div className="label">{k}</div>
              <div className="font-display text-3xl mt-2 text-[#d4af37]">{val}</div>
            </div>
          ))}
        </div>

        <h2 className="font-display text-2xl mt-14 mb-4">Live FX Feed</h2>
        <div className="panel p-4 grid grid-cols-2 md:grid-cols-4 gap-3">
          {Object.values(rates).map((r) => (
            <div key={r.code} className="p-3 border border-white/5 rounded" data-testid={`fx-${r.code}`}>
              <div className="flex justify-between items-center">
                <span className="font-mono text-sm">{r.code}</span>
                <span className={`chip ${r.source === "live" ? "green" : "gold"}`}>{r.source}</span>
              </div>
              <div className="font-display text-xl text-[#d4af37] mt-1">${r.rate_usd?.toFixed(4)}</div>
              <div className="text-[10px] text-white/50 font-mono mt-1">{r.name}</div>
            </div>
          ))}
        </div>

        <h2 className="font-display text-2xl mt-14 mb-4">Changelog</h2>
        <div className="space-y-6">
          {versions.map((ver) => (
            <div key={ver} className="panel p-6" data-testid={`changelog-${ver}`}>
              <div className="chip gold mb-3">v{ver}</div>
              <ul className="space-y-2">
                {grouped[ver].map((m) => (
                  <li key={m.key} className="flex gap-3 text-sm">
                    <CheckCircle2 size={14} className="text-[#39ff14] shrink-0 mt-1"/>
                    <span><b className="text-white">{m.name}</b> <span className="text-white/60">— {m.desc}</span></span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
      <footer className="border-t border-white/10 py-8 text-center text-xs text-white/40 font-mono">© 2026 BlackStar Virtual Mint · shareable status</footer>
    </div>
  );
}
